export type AvatarCrop = { x: number; y: number; zoom: number };
export const DEFAULT_AVATAR_CROP: AvatarCrop = { x: 0.5, y: 0.5, zoom: 1 };

export function avatarCropRect(width: number, height: number, crop = DEFAULT_AVATAR_CROP) {
  if (width <= 0 || height <= 0 || !Number.isFinite(width + height))
    throw new Error('That photo has invalid dimensions.');
  const zoom = Number.isFinite(crop.zoom) ? Math.max(1, Math.min(5, crop.zoom)) : 1;
  const side = Math.min(width, height) / zoom;
  const x = Number.isFinite(crop.x) ? crop.x : 0.5;
  const y = Number.isFinite(crop.y) ? crop.y : 0.5;
  return {
    x: Math.max(0, Math.min(width - side, x * width - side / 2)),
    y: Math.max(0, Math.min(height - side, y * height - side / 2)),
    side,
    zoom,
  };
}

export function clampAvatarCrop(width: number, height: number, crop: AvatarCrop): AvatarCrop {
  const rect = avatarCropRect(width, height, crop);
  return {
    x: (rect.x + rect.side / 2) / width,
    y: (rect.y + rect.side / 2) / height,
    zoom: rect.zoom,
  };
}
